import React from 'react'

import {
  TagComponent, Icon, Verified, VerifiedIcon, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

function ModelCardVerifiedTag({
  isCgtVerified = false, isVisible, isPrintReady = false,
}) {
  if (!isCgtVerified) {
    return null
  }

  return (
    <div className={classnames(
      'card-3d-model__verified-tag',
      isVisible && 'card-3d-model__verified-tag--visible',
    )}
    >
      {isPrintReady ? (
        <TagComponent
          type="ghost"
          className="card-3d-model__verified-tag--3d-print-verified"
        >
          {/* Triangle's size names are off by a step inside a tag: `.cgt-tag * > svg` stretches the
              glyph to the wrapper's height, and `.cgt-icon--small` is a 24px box. `tiny` is the
              16px one, matching the sibling subscription badge. */}
          <Icon
            svgComponent={Verified}
            size="tiny"
            notSpaced
            className="card-3d-model__verified-tag-icon"
          />
          3D PRINT VERIFIED
        </TagComponent>
      ) : (
        <TagComponent
          type="primary"
          backColor="legacy-brand-primary-100"
          leadIcon={<Icon svgComponent={VerifiedIcon} />}
        />
      )}
    </div>
  )
}

ModelCardVerifiedTag.propTypes = {
  isCgtVerified: bool,
  isVisible: bool.isRequired,
  isPrintReady: bool,
}

export default ModelCardVerifiedTag
